var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UnitsFrame',[(_vm.flashcardsByMazo.results)?_c('MazoForm',{attrs:{"current-mazo":_vm.flashcardsByMazo},on:{"setNewsFlashcards":_vm.setNewsFlashcards}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }